<div class="d-flex flex-column gap-2">
  <div class="d-flex gap-2 align-items-center justify-content-between">
    <span>{{ description }}</span>
    <ng-content select="[header-actions]"></ng-content>
  </div>
  <div class="d-flex flex-wrap column-gap-4 mb-2 justify-content-start">
    <div style="display: flex; flex-direction: row; gap: 12px">
      <ng-content></ng-content>
    </div>
  </div>
</div>
